import FJUrlToVideoScriptEdit from './FJUrlToVideoScriptEdit';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import { setSliceUseSpiderImage } from '../../../redux/slices/FJSliceTextToVideo';
import { useCallback } from 'react';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJEvent from '../../../store/FJEvent';
const FJUrlToVideoScriptEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const spiderData = useSelector(state => state.textToVideo.spiderData);
    const useSpiderImage = useSelector(state => state.textToVideo.useSpiderImage);
    const setUseSpiderImage = useCallback(
        value => {
            dispatch(setSliceUseSpiderImage(value));
        },
        [dispatch],
    );
    const addSceneText = useCallback(
        options => {
            dispatch(
                FJActionTextToVideo.onUpdateSceneTextListAction(null, {
                    ...options,
                    type: FJ_EVENT_TYPE.ADD,
                    ignoreFocus: true,
                }),
            );
            setTimeout(() => {
                FJEvent.dispatch(FJ_EVENT_TYPE.SCROLL_SCENE_TO_END);
            }, 200);
        },
        [dispatch],
    );
    const onSpiderEditNext = useCallback(() => {
        dispatch(FJActionTextToVideo.onAnalyzeUrlNextAction());
    }, [dispatch]);
    return (
        <FJUrlToVideoScriptEdit
            spiderData={spiderData}
            useSpiderImage={useSpiderImage}
            setUseSpiderImage={setUseSpiderImage}
            addSceneText={addSceneText}
            onSpiderEditNext={onSpiderEditNext}
        />
    );
};

export default FJUrlToVideoScriptEditContainer;
